export const header = () => {
  const header = document.querySelector('.header');
  if (!header) return;
  const headerHeight = header.offsetHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY > headerHeight) {
      header.classList.add('is-fixed');
    } else {
      header.classList.remove('is-fixed');
    }
  });
}